
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import quickInfo from "@/page/factory/quickInfo.vue";
import { UserService } from "@/service/UserService";

@Component
export default class QuickInfoUser extends quickInfo {
  @Prop() code: string;

  pageInit: boolean = true;

  setKbnList() { // mounted => setKbnList
    const userService = new UserService();

    // 都道府県情報を取得する
    const promisePrefectures = userService.getPrefecturesPM();

    // レバレートの情報を取得する
    const promiseLaborRate = userService.getLaborRatePM();

    // ﾅﾝﾊﾞｰﾌﾟﾚｰﾄの情報を取得する
    const promisePlateArea = userService.getPlateAreasFrequentPM();

    // スタッフの情報を取得する
    this.reqService.getStaffFront().then(
      (res: any) => {
        if (res) {
          this.staffs = res;
          if (this.carFormQuickInfo.frontTantoushaCd == null || this.carFormQuickInfo.frontTantoushaCd == "") {
            if (this.staffs.length > 0) {
              // mountedですると、タイミングによりセットされない。親クラスのcreatedのpromise内にあるgetDataがズレて呼ばれることがあるため
              this.carFormQuickInfo.frontTantoushaCd = this.staffs[0].staffCd;
              this.updateFrontStaff({
                staffCd: this.staffs[0].staffCd,
                staffNm: this.staffs[0].staffNm
              });
            }
          }
        }
      },
      (err: any) => {
        this.staffs = [];
      }
    );
    if (this.carForm.soukouUnitKbn != null) {
      this.changeSoukouUnit();
    }

    Promise.all([promisePrefectures, promiseLaborRate, promisePlateArea]).then((val: any) => {
      if (val) {
        if (val.length > 0) {
          this.listPrefectures = val[0];
        }
        if (val.length > 1) {
          this.$set(this, "labors", val[1]);
        }
        if (val.length > 2) {
          this.listPlateAreaFrequent = val[2];
        }
      }

      if (this.pageInit && this.code) {
        // console.log("quickInfoUser.created", this.code);
        this.pageInit = false;
        // 初回のみパラメータのクイック見積IDの情報を取得する
        this.getQuickMitsumoriData();
      }
    });
  }

  onNext() {
    this.$router.push({ name: "user-quickitemselection"} );
  }

  getQuickMitsumoriData() {
    let promise = this.getQuickMitsumoriPM();
    this.$set(this, "loading", true);
    Promise.all([promise]).then((val: any) => {
      if (val && val.length > 0) {
        const e = val[0];
        this.currentRowSelectQuick = {...e};
        this.torokubangoDialogSelected = (e && e.sknQuickMitsumoriId) ? e.sknQuickMitsumoriId : "";
        this.setQuickMitsumoriData();
      }
      this.$set(this, "loading", false);
    });
  }

  getQuickMitsumoriPM() {
    let promise = new Promise((resolve, reject) => {
      this.reqService.getQuickMitsumoriByIdForCustomer(this.code).then((response: any)=> {
        if (response) {
          resolve(response);
        } else {
          reject();
        }
      },
      (err: any) => {
        reject();
      });
    });
    return promise;
  }
}
